import { useIsMobile } from '@/shared/utils'
import { Skeleton } from '../shadcn'
import { BlockSkeleton } from './BlockSkeleton'
import { ItemLayoutSkeleton } from './ItemLayoutSkeleton'

export const BasePageSkeleton = () => {
  const isMobile = useIsMobile()
  return (
    <>
      <div className="flex justify-between items-center mb-8">
        <ItemLayoutSkeleton />
        {!isMobile && (
          <div className="flex flex-col items-end gap-2">
            <Skeleton className="w-[150px] h-8" />
            <Skeleton className="w-[180px] h-6" />
          </div>
        )}
      </div>
      <Skeleton className="mb-5 w-full h-[250px] md:h-[100px]" />
      <div className="flex flex-col gap-[30px]">
        <BlockSkeleton />
        <BlockSkeleton />
        <BlockSkeleton />
      </div>
    </>
  )
}
